<template>
  <el-dialog
    :title="title"
    :visible.sync="vDialog"
    width="550px"
    height="600px"
    :close-on-click-modal="false"
  >
    <section :loading="listLoading">
      <!--列表-->
      <el-tree
        :props="props"
        :data="sysOrgData"
        show-checkbox
        @check-change="handleCheckChange"
        :check-strictly="checkstrictly"
      ></el-tree>
    </section>
    <div slot="footer" class="dialog-footer">
      <el-button @click="vDialog = false">取消</el-button>
      <el-button type="primary" @click="callback">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import util from "../../util/date";
import { getSysOrgListPage } from "../api/api";

export default {
  name: "getSysOrg",
  props: {
    title: {
      type: String,
      default: () => {
        return "机构管理";
      },
    },
    //弹出框的显示状态
    visibleDialog: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      listLoading: false,
      sysOrgData: [],
      props: {
        label: "Name",
        children: "children",
      },
      selectOrg: [],
      vDialog: this.visibleDialog,
      currentData: [],
      checkstrictly: true,
    };
  },
  watch: {
    visibleDialog(val) {
      this.vDialog = val;
    },
    vDialog(val) {
      this.$emit("DialogVisibleChange", val);
    },
  },
  mounted() {
    this.getSysOrg();
  },
  methods: {
    callback() {
      this.$emit("callback", this.currentData);
    },
    formatCreateTime(row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.CreateTime),
            "yyyy-MM-dd hh:mm:ss"
          );
    },
    handleCheckChange(val) {
      this.currentData = val;
      
      // if(this.currentData.length>1){
      //   this.currentData.shift();
      // }
    },
    //获取用户列表
    getSysOrg() {
      this.listLoading = true;
      getSysOrgListPage(null).then((res) => {
        let data = res.data.response.data;
        //处理父子结构数据
        data.map((x) => {
          x["children"] = data.filter((y) => y.PID == x.Id);
        });
        data = data.filter(
          (x) => x.PID == "00000000-0000-0000-0000-000000000000"
        );
        this.sysOrgData = data;
        this.listLoading = false;
      });
    },
  },
};
</script>

<style scoped>
</style>
